module.exports = __webpack_public_path__ + "img/pic_casino_popup_ads@3x.5f39097d.png";